<template>
    <section>
        <div class="row mx-0">
            <div class="col-md-12 pt-3 my-0">
                <div class="row mx-0 justify-content-center align-items-center position-relative">
                    <img :src="require('@/assets/termos/img1.fw.png')" class="position-absolute"
                        style="top: 0; left: 0; z-index: 2;">
                    <img :src="require('@/assets/termos/img2.fw.png')" class="position-absolute"
                        style="bottom: 0; left: 0; z-index: 2;">
                    <img :src="require('@/assets/termos/img3.fw.png')" class="position-absolute"
                        style="top: 0; right: 0; z-index: 2;">
                    <img :src="require('@/assets/termos/img4.fw.png')" class="position-absolute"
                        style="bottom: 0; right: 0; z-index: 2;">
                    <div class="col-12 col-lg-5 py-3 pl-5">
                        <h3 class="pt-5"><strong>Termos e Condições</strong></h3>
                        <p class="my-5">Para utilizar nossos serviços, leia e aceite nossos termos e condições de uso da
                            plataforma. </p>
                        <template v-for="eula in termos">
                            <div :key="eula.fk_termo_id">
                                <p :class="{'text-bold text-red': invalid && !eula.aceito}">
                                    <p-check v-model="eula.aceito" class="p-default p-curve" :color="appLayout.check">
                                        Concordo que li e aceito</p-check>
                                    <a href="#" @click="showTermo(eula.termo)">{{eula.termo.termo_descricao}}</a>
                                </p>
                            </div>
                        </template>
                        <div class="col-5" style="z-index: 5;">
                            <button @click="aceitar()" :disabled="loading" class="btn btn-primary">
                                <i class="fa fa-check"></i>
                                Aceito os termos
                                <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i>
                            </button>
                        </div>
                    </div>
                    <div class="d-none d-lg-block col-lg-7 text-center">
                        <img :src="require('@/assets/termos/Imagemtermo.fw.png')" width="100%" alt="termos">
                    </div>
                </div>
            </div>
        </div>
        <div id="ModalShowEula" class="modal" data-backdrop="static" data-keyboard="true"  role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title"><b>{{selectedEula.termo_descricao}} -
                                {{formatDate(selectedEula.termo_data)}}</b></h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body py-0">
                        <section style="height: 500px;overflow: scroll;" v-if="selectedEula"
                            v-html="selectedEula.termo_conteudo"></section>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" data-dismiss="modal" class="btn btn-default"><i class="fa fa-times"></i>
                            {{$t('words.close')}} </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'page451',
        data() {
            return {
                loading: false,
                invalid: false,
                dialogVisible: false,
                termos: [],
                selectedEula: {}
            };
        },
        mounted() {
            if (this.$route.params.termos) {
                this.termos = this.$route.params.termos;
            } else {
                this.$store.dispatch('getEula').then(response => {
                    if (response.status == 'success') {
                        this.eula = response.eula;
                        return
                    }
                    this.$router.push({
                        path: '/dashboard'
                    });
                });
            }
        },
        methods: {
            showTermo(termo) {
                this.selectedEula = termo;
                $('#ModalShowEula').modal('toggle');
            },
            aceitar() {
                this.invalid = this.termos.findIndex(x => !x.aceito) > -1;
                if (this.invalid) {
                    toastr({
                        icon: 'error',
                        title: 'Por favor, aceite os termos para continuar.'
                    });
                    return;
                }
                let termosId = [];
                this.termos.map(item => {
                    termosId.push(item.fk_termo_id);
                });
                this.loading = true;
                this.$store.dispatch('aceitarTermos', {
                    termos: termosId
                }).then(response => {
                    this.loading = false;
                    toastr({
                        title: 'Termo aceito, iremos te redirecionar',
                        icon: 'success'
                    });
                    this.$router.push({
                        path: '/dashboard'
                    });
                });
            }
        },
        watch: {
            $route(data) {
                this.$destroy();
            }
        },
    };
</script>

<style scoped>
    .row.position-relative {
        height: 72vh !important;
    }

    h2 {
        font-size: 4rem;
    }

    p.my-5 {
        font-size: large;
    }

    img:not(.position-absolute) {
        max-width: 400px;
        z-index: 1;
    }

    button.btn {
        font-size: medium;
    }

    button.btn.btn-default {
        background-color: #f4f4f4;
        color: #444;
        border-color: #ddd;
    }

    .fade {
        height: 105vh !important;
    }

    .modal-dialog {
        max-width: 80vw;
        margin-bottom: 0px;
    }

    .modal-content {
        /* width: 90vw; */
        height: 90vh;
    }

    .modal-body {
        max-height: 100% !important;
        padding: 0;
    }

    .modal-body section {
        height: 100% !important;
        overflow-x: hidden !important;
        padding: 0 1rem;
    }
</style>